(function () {
  var drawer = document.querySelector('[data-lpd-cart-drawer]');
  var overlay = document.querySelector('[data-lpd-cart-overlay]');
  var closeBtn = document.querySelector('[data-lpd-cart-close]');
  var itemsEl = document.querySelector('[data-lpd-cart-items]');
  var countEl = document.querySelector('[data-lpd-cart-count]');
  var totalEl = document.querySelector('[data-lpd-cart-total]');
  var discountInput = document.querySelector('[data-lpd-discount-input]');
  var discountBtn = document.querySelector('[data-lpd-discount-apply]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (drawer) drawer.classList.add('lpd-active');
    if (overlay) overlay.classList.add('lpd-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('lpd-active');
    if (overlay) overlay.classList.remove('lpd-active');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    if (countEl) countEl.textContent = cart.item_count;
    if (totalEl) totalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="lpd-cart-empty">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image : '';
      return (
        '<div class="lpd-cart-line" data-line-key="' + item.key + '">' +
          (img ? '<img src="' + img + '&width=128" alt="">' : '<div></div>') +
          '<div>' +
            '<div class="lpd-cart-line-title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="lpd-cart-line-variant">' + item.variant_title + '</div>' : '') +
            '<div class="lpd-cart-line-price">' + money(item.final_line_price) + '</div>' +
            '<div class="lpd-cart-line-qty">' +
              '<button type="button" data-qty-decrease>-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="lpd-cart-line-remove" data-qty-remove>Remove</button>' +
        '</div>'
      );
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function (err) { console.error(err); });
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');

      if (e.target.matches('[data-qty-increase]')) {
        var current = parseInt(line.querySelector('.lpd-cart-line-qty span').textContent, 10);
        changeLine(key, current + 1);
      } else if (e.target.matches('[data-qty-decrease]')) {
        var current2 = parseInt(line.querySelector('.lpd-cart-line-qty span').textContent, 10);
        changeLine(key, Math.max(0, current2 - 1));
      } else if (e.target.matches('[data-qty-remove]')) {
        changeLine(key, 0);
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (discountBtn && discountInput) {
    discountBtn.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    });
  }

  function initBuyWidget(form) {
    var sectionId = form.id.replace('lpd-buy-form-', '');
    var radios = form.querySelectorAll('input[type="radio"][name="lpd-tier-' + sectionId + '"]');
    var qtyInput = document.getElementById('lpd-qty-' + sectionId);
    var submitBtn = document.getElementById('lpd-submit-' + sectionId);
    var priceEl = submitBtn ? submitBtn.querySelector('[data-lpd-btn-price]') : null;

    function applySelected(radio) {
      if (!radio) return;
      var qty = radio.value || '1';
      var price = radio.getAttribute('data-price') || '';
      if (qtyInput) qtyInput.value = qty;
      if (priceEl) priceEl.textContent = price;

      radios.forEach(function (r) {
        var label = r.closest('.lpd-tier');
        if (label) label.classList.toggle('lpd-tier-selected', r === radio);
      });
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        applySelected(radio);
      });
    });

    var initiallyChecked = form.querySelector('input[type="radio"]:checked') || radios[0];
    applySelected(initiallyChecked);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var originalText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetchCart();
        })
        .then(function () {
          openDrawer();
        })
        .catch(function (err) {
          console.error(err);
          alert('Something went wrong adding this to your cart. Please try again.');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalText;
          }
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.lpd-buy-form').forEach(initBuyWidget);
  });
})();